import { SelectField } from '@eventbrite/marmalade';
import React from 'react';

export interface DropdownItem {
  value: string;
  label: string;
}
export interface DropdownProps {
  dropdownItems: DropdownItem[];
  placeholder: string;
  selectedOption: string | null;
  setSelectedOption: (option: string) => void;
  isDisabled: boolean;
  validation?: string;
}

const Dropdown: React.FC<DropdownProps> = ({
  dropdownItems,
  placeholder,
  selectedOption,
  setSelectedOption,
  isDisabled,
  validation,
}) => {
  return (
    <div>
      <SelectField
        options={dropdownItems}
        label={placeholder}
        required={true}
        value={selectedOption ?? ''}
        onChange={setSelectedOption}
        hasError={!!validation}
        helperText={validation}
        onPointerEnterCapture={undefined}
        onPointerLeaveCapture={undefined}
        disabled={isDisabled}
      ></SelectField>
    </div>
  );
};

export default Dropdown;
